import Vue from 'vue'
import VueRouter from 'vue-router'
import Company from '@/components/Company.vue'
import YqhxApp from '@/components/YqhxApp.vue'
import HelloWorld from '@/components/HelloWorld.vue'
import Buy from '@/components/Buy.vue'
import ContactUs from '@/components/ContactUs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Company
  },
  {
    path: '/product/yqhx-app',
    name: 'product-yqhx-app',
    component: YqhxApp
  },
  {
    path: '/research',
    name: 'research',
    component: HelloWorld
  },
  {
    path: '/buy',
    name: 'buy',
    component: Buy
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactUs
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
